import { Component } from '@angular/core';
import { SharedModule } from '../../modules/shared/shared.module';

@Component({
  selector: 'app-access-denied-page',
  standalone: true,
  imports: [SharedModule],
  template: '<app-access-denied></app-access-denied>'
})
export class AccessDeniedPageComponent { }
